import { useCallback, useEffect, useState } from 'react';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';
import { ProviderService } from '../../services/providers/providerService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage provider fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de proveedores.
----------------------------------------------------------------------------------------*/

const useProviders = () => {

    const { userCan } = usePrivilege();
    const [data, setData] = useState<any[]>([]);

    const fetchProviders = useCallback(async () => {
        try {
            if (!userCan('list', 'provider')) return;   
            const service = new ProviderService();
            const response = await service.listForSelect({ limit: 999999 });
            const fetchedData = response.getResponseData();

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; companyName: string; }) => ({
                    value: data.id,
                    label: data.companyName,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching providers:', error);
        }
    }, []);

    useEffect(() => {
        fetchProviders();
    }, []);

    const getProvidersList = () => {
        return data;
    };

    return { fetchProviders, getProvidersList };    
}

export default useProviders;
